import type { FC } from "react";

export const TooltipButton: FC<{
  label: string;
  onClick: () => void;
  children: React.ReactNode;
}> = ({ label, onClick, children }) => (
  <button
    aria-label={label}
    className="group relative flex cursor-pointer items-center justify-center p-2 text-gray"
    onClick={onClick}
    type="button"
  >
    {children}
    {/* Tooltip */}
    <span className="pointer-events-none absolute bottom-full mb-2 hidden rounded bg-gray-800 px-2 py-1 text-xs text-white opacity-0 transition-opacity group-hover:block group-hover:opacity-100">
      {label}
    </span>
  </button>
);
